import React from 'react';
import { observer } from 'mobx-react';
import SVGIconView from 'lib/images/svg-icon-view';

import like from 'four-nets/icons/svg/icon_like.svg';
import SocialButtonView from './social-button-view';
import { FormattedMessage } from 'react-intl';

@observer
class LikeButtonView extends React.Component {
    render() {
        const { theme, liked, ...rest } = this.props;

        return (
            <SocialButtonView
                {...rest}
                icon={<SVGIconView src={like} />}
                label={!liked ? <FormattedMessage id='LIKE' /> : <FormattedMessage id='UNLIKE' />}
            />
        );
    }
}

export default LikeButtonView;
